import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    name: 'Valentina',
    text: 'Llevaba 3 años con acné adulto. Había probado de todo. Llevo 2 meses con la rutina RIMAN y por primera vez salgo a la calle sin base de maquillaje. Es increíble.',
    rating: 5
  }, {
    name: 'Camila',
    text: 'Empecé por mi piel sensible y terminé uniéndome al Glow Up. No solo mi piel está radiante, sino que este mes pagué la cuota del auto solo con mis recomendaciones.',
    rating: 5
  }, {
    name: 'Daniela',
    text: 'Me daba miedo invertir porque ya había gastado mucho antes. Pero la textura de mi piel cambió en la primera semana. El Active Clean-Up Powder es magia.',
    rating: 5
  }];
  return <section className="py-24 bg-brand-cream relative overflow-hidden" data-id="element-217" data-mp="2yeo02i0u50aj">
      <div className="absolute top-0 right-1/4 w-64 h-64 bg-brand-beige/30 rounded-full blur-3xl -z-10" data-id="element-218" data-mp="2ydcxglj4lyl0" />
      <div className="container mx-auto px-6 md:px-12 relative z-10" data-id="element-219" data-mp="2v1kskqf6sdwt">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center max-w-2xl mx-auto mb-16" data-id="element-220" data-mp="2uzrkr7su7nn8">
          <h2 className="text-4xl md:text-5xl font-serif text-brand-charcoal mb-4" data-id="element-221" data-mp="34t8c855i4qnq">
            Lo que dicen nuestras clientas 🤍
          </h2>
          <p className="text-brand-charcoal/70" data-id="element-222" data-mp="2c3rovlwqnzyd">
            Historias reales de transformación 💋
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-223" data-mp="275gd35mvvfdi">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white/90 backdrop-blur-sm p-8 rounded-2xl shadow-sm relative border border-brand-beige/30 soft-glow-hover transition-all hover:-translate-y-1" data-id="element-224" data-mp="2lyte0hr0l20y" data-mpi={index}>
              {/* Chat bubble tail */}
              <div className="absolute -bottom-3 left-8 w-6 h-6 bg-white border-b border-r border-brand-beige/30 transform rotate-45" data-id="element-225" data-mp="8caiqwt7i2i7" />

              <div className="flex gap-1 mb-4" data-id="element-226" data-mp="ic1c2v616bgp">
                {[...Array(testimonial.rating)].map((_, i) => <Star key={i} className="w-4 h-4 fill-brand-gold text-brand-gold" data-id="element-227" data-mp="3gtott19uqwx4" data-mpi={i} />)}
              </div>
              <p className="text-brand-charcoal/80 font-light italic mb-6 leading-relaxed" data-id="element-228" data-mp="3lsrq9xbrnuth">
                "{testimonial.text}"
              </p>
              <p className="font-serif font-medium text-brand-charcoal" data-id="element-229" data-mp="3qr2zc5u8m1an">
                — {testimonial.name}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}